var _title, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 220,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    id: "svg_10",
    d: "M 145.087 113.521 L 122.214 136.394 L 81.195 133.496 L 78.297 92.477 L 101.162 69.612 C 101.546 69.012 102 68.443 102.525 67.918 L 154.796 15.646 C 158.701 11.741 165.033 11.741 168.938 15.646 L 198.859 45.567 C 202.764 49.472 202.764 55.804 198.859 59.709 L 146.587 111.98 C 146.065 112.502 145.5 112.954 144.903 113.337 L 145.087 113.521 Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 194.35 96.677 L 194.35 121.677 C 194.35 121.711 194.35 121.744 194.349 121.778 L 194.349 190.237 C 194.349 195.76 189.872 200.237 184.349 200.237 L 33.343 200.237 C 27.82 200.237 23.343 195.76 23.343 190.237 L 23.343 32.722 C 23.343 27.199 27.82 22.722 33.343 22.722 L 88.912 22.722 C 89.607 22.722 114.471 22.688 114.471 22.688 C 117.364 22.688 119.471 24.927 119.471 27.688 L 119.471 35.688 C 119.471 38.449 117.215 40.649 114.471 40.649 C 94.46 40.649 88.798 40.651 88.464 40.581 L 45 40.581 C 42.239 40.581 40 42.82 40 45.581 L 40 178.581 C 40 181.342 42.239 183.581 45 183.581 L 171 183.581 C 173.761 183.581 176 181.342 176 178.581 L 176 96.785 C 176 94.023 178.239 91.772 181 91.755 L 189.35 91.707 C 192.111 91.691 194.35 93.916 194.35 96.677 Z M 176 121.785 C 176 121.785 176 121.785 176 121.785 Z",
    id: "svg_19",
    stroke: "#000",
    fill: "#000000",
    style: {}
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e3b0d799c3129a0912c99dc887f2a1b7.svg";
export { ForwardRef as ReactComponent };